function LoadingState({ message = 'Yukleniyor...', size = 'md', className = '' }) {
  const spinnerClass = size === 'lg' ? 'spinner spinner--lg' : 'spinner';
  const rootClass = ['loading-state', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} role="status" aria-live="polite">
      <span className={spinnerClass} aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}

export default LoadingState;
